// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"137":"dc3e63805c071ab4","458":"e0d267e318e1ccc3"}[chunkId] + ".css";
};